'use client';

import { SEMESTER_OPTIONS } from '@/app/lib/semesters';

export function DiscoverySemesterSelect({ semester, onChange }: { semester: string; onChange: (semester: string) => void }) {
  return <label className="block min-w-0 text-sm font-medium text-content">Semester
    <select className="ss-field mt-1 min-h-12 w-full" value={semester} onChange={(event) => onChange(event.target.value)}>
      {SEMESTER_OPTIONS.map(({ id, label }) => <option key={id} value={id}>{label}</option>)}
    </select>
  </label>;
}
